import React from 'react'
import map from 'ramda/src/map'
import Typography, { typographyVariants } from 'root/src/client/web/typography/Typography'
import ButtonNew from 'root/src/client/web/base/ButtonNew'
import Icon from 'root/src/client/web/base/Icon'
import withStyles from '@material-ui/core/styles/withStyles'
import Anchor from 'root/src/client/web/base/Anchor'
import { colorsNew, ltSmMediaQuery, gtMdMediaQuery, smMediaQuery, gtSmMediaQuery } from 'root/src/client/web/commonStyles'

const style = {
	howToContainer: {
		display: 'flex',
		backgroundColor: colorsNew.dark2,
		margin: [[60, 'auto']],
		padding: [[50, 80]],
		flexDirection: 'column',
		justifyContent: 'space-around',
		alignItems: 'center',
		borderRadius: 40,
		[ltSmMediaQuery]: {
			padding: [[50, 20]],
		},
		[gtSmMediaQuery]: {
			boxSizing: 'border-box',
			width: '100%',
			height: 570,
			margin: [[30, 'auto']],
			padding: [[30, 80]],
		},
	},
	headingContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	howToItemsContainer: {
		display: 'flex',
		[ltSmMediaQuery]: { flexDirection: 'column' },
	},
	item: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		margin: 50,
		justifyContent: 'space-between',
		[ltSmMediaQuery]: {
			margin: [[25, 60]],
		},
		[smMediaQuery]: {
			margin: 25,
		},
		[gtMdMediaQuery]: {
			padding: [[0, 25]],
		},
	},
	buttonsContainer: {
		display: 'flex',
		justifyContent: 'space-around',
		width: '50%',
		[ltSmMediaQuery]: {
			flexDirection: 'column',
			margin: [[25, 0]],
			justifyContent: 'space-between',
		},
		[gtMdMediaQuery]: {
			width: '30%',
		},
	},
	button: {
		[ltSmMediaQuery]: {
			margin: [[7, 0]],
		},
	},
	typography: {
		textAlign: 'center',
	},
}
const HowToSection = ({ classes, pageContent, displayModal }) => (
	<div
		className={classes.howToContainer}
	>
		<div className={classes.headingContainer}>
			<Typography
				variant={typographyVariants.heading2}
				className={classes.typography}
			>{pageContent.title}
			</Typography>
			<Typography
				variant={typographyVariants.paragraph}
				className={classes.typography}
			>{pageContent.subtitle}
			</Typography>
		</div>
		<div className={classes.howToItemsContainer}>
			{map(({ icon, cta, content }) => (
				<div key={cta} className={classes.item}>
					<Icon glow={icon.color} icon={icon.icon} size={40} />
					<Typography
						variant={typographyVariants.paragraphBold}
						className={classes.typography}
					>
						{cta}
					</Typography>
					<Typography
						variant={typographyVariants.small}
						className={classes.typography}
					>
						{content}
					</Typography>
				</div>
			), pageContent.steps)}
		</div>
		<div className={classes.buttonsContainer}>
			{map(({ label, type, moduleId, anchorId }) => (moduleId
				? (
					<ButtonNew
						key={label}
						type={type}
						className={classes.button}
						onClick={() => displayModal(moduleId)}
					>
						{label}
					</ButtonNew>
				) : (
					<Anchor key={label} spy={false} anchor={anchorId}>
						<ButtonNew type={type} className={classes.button}>
							{label}
						</ButtonNew>
					</Anchor>
				)
			), pageContent.buttons)}
		</div>
	</div>
)

export default withStyles(style, { name: 'MuiHowToSection' })(HowToSection)
